// extracted by mini-css-extract-plugin
export const title = "blog-post-module--title--1uZ-o typography-module--responsiveTitle1--2aak3";
export const mainImage = "blog-post-module--mainImage--bB9Ee";
export const grid = "blog-post-module--grid--3wRA5";
export const mainContent = "blog-post-module--mainContent--3bHQt";
export const metaContent = "blog-post-module--metaContent--IH9IS";
export const publishedAt = "blog-post-module--publishedAt--2Vzf7 typography-module--small--2jpCI";
export const categories = "blog-post-module--categories--3zhTU";
export const categoriesHeadline = "blog-post-module--categoriesHeadline---x0dT typography-module--base--2DtHq";